"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ECDSAOwnershipRegistryModule_v100__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "smartAccount",
                type: "address",
            },
        ],
        name: "AlreadyInitedForSmartAccount",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "smartAccount",
                type: "address",
            },
        ],
        name: "NoOwnerRegisteredForSmartAccount",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "NotEOA",
        type: "error",
    },
    {
        inputs: [],
        name: "WrongSignatureLength",
        type: "error",
    },
    {
        inputs: [],
        name: "ZeroAddressNotAllowedAsOwner",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "smartAccount",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "oldOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        inputs: [],
        name: "NAME",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "VERSION",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "smartAccount",
                type: "address",
            },
        ],
        name: "getOwner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "eoaOwner",
                type: "address",
            },
        ],
        name: "initForSmartAccount",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "dataHash",
                type: "bytes32",
            },
            {
                internalType: "bytes",
                name: "moduleSignature",
                type: "bytes",
            },
        ],
        name: "isValidSignature",
        outputs: [
            {
                internalType: "bytes4",
                name: "",
                type: "bytes4",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "dataHash",
                type: "bytes32",
            },
            {
                internalType: "bytes",
                name: "moduleSignature",
                type: "bytes",
            },
            {
                internalType: "address",
                name: "smartAccount",
                type: "address",
            },
        ],
        name: "isValidSignatureForAddress",
        outputs: [
            {
                internalType: "bytes4",
                name: "",
                type: "bytes4",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "sender",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "nonce",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes",
                        name: "initCode",
                        type: "bytes",
                    },
                    {
                        internalType: "bytes",
                        name: "callData",
                        type: "bytes",
                    },
                    {
                        internalType: "uint256",
                        name: "callGasLimit",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "verificationGasLimit",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "preVerificationGas",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "maxFeePerGas",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "maxPriorityFeePerGas",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes",
                        name: "paymasterAndData",
                        type: "bytes",
                    },
                    {
                        internalType: "bytes",
                        name: "signature",
                        type: "bytes",
                    },
                ],
                internalType: "struct UserOperation",
                name: "userOp",
                type: "tuple",
            },
            {
                internalType: "bytes32",
                name: "userOpHash",
                type: "bytes32",
            },
        ],
        name: "validateUserOp",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class ECDSAOwnershipRegistryModule_v100__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.ECDSAOwnershipRegistryModule_v100__factory = ECDSAOwnershipRegistryModule_v100__factory;
ECDSAOwnershipRegistryModule_v100__factory.bytecode = _bytecode;
ECDSAOwnershipRegistryModule_v100__factory.abi = _abi;
//# sourceMappingURL=ECDSAOwnershipRegistryModule_v100__factory.js.map